import React, { FC, ReactNode } from 'react';
import getClassName from 'src/common/utils/getClassName';
import styles from './UnavailableEditorSection.module.scss';

type Props = {
  title: string;
  description?: string;
  children?: ReactNode;
  classNameModifier?: string;
};
const UnavailableEditorSection: FC<Props> = ({
  title,
  description,
  children,
  classNameModifier = '',
}) => (
  <div className={getClassName(styles, 'root', classNameModifier)}>
    <h4 className={styles.title}>{title}</h4>
    {description && <p className={styles.description}>{description}</p>}
    {children}
  </div>
);

export default UnavailableEditorSection;
